var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
import { Component, CustomElement, Prop, Event, EventEmitter, html, svg } from '@sick-davinci/ce-decorators';
import { style } from './Collapse.style';
/**
 * A collapse can be used to show and hide content.
 * 
 * @example
 * ```html
 * <davinci-collapse collapsed-title="Show me" expanded-title="Hide me" >
 *  <div style="background-color: rgb(204, 137, 49)">
 *      Custom titles for collapsed and expanded state.
 *      Closed-state
 *  </div>
 * </davinci-collapse>
 * ```
 * @slot {*} content of the collapsable
 */

export let Collapse = (_dec = Component({
  tag: 'davinci-collapse',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Event('open-state-change'), _dec11 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec(_class = (_class2 = (_temp = class Collapse extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "open", _descriptor, this);

    _initializerDefineProperty(this, "prependIcon", _descriptor2, this);

    _initializerDefineProperty(this, "collapsedTitle", _descriptor3, this);

    _initializerDefineProperty(this, "expandedTitle", _descriptor4, this);

    _initializerDefineProperty(this, "changed", _descriptor5, this);

    this.handleOnClick = () => {
      this.open = !this.open;
      this.changed.emit(this.open);
    };
  }

  render() {
    return html`
      <div class="accordion" @click=${this.handleOnClick}>
        ${this._getCurrentAccordionPartial(this.open)}
        ${svg`
        <svg class="${this.open ? 'active ' : ''}${this.prependIcon ? 'prepend ' : ''}" width="24px" height="24px" viewBox="0 0 24 24"
                      version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Shape">
            <polygon points="7.41 8.4864 12 12.8832 16.59 8.4864 18 9.84 12 15.6 6 9.84"></polygon>
          </g>
        </svg>`}
      </div>
      <div class="${'panel' + (this.open ? ' open' : '')}">
        <slot></slot>
      </div>
    `;
  }

  _getCurrentAccordionPartial(state) {
    return state ? html`<div class="title">${this.expandedTitle}</div>` : html`<div class="title">${this.collapsedTitle}</div>`;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "open", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "prependIcon", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "collapsedTitle", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'Show';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "expandedTitle", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'Hide';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "changed", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
//# sourceMappingURL=Collapse.js.map